import React from 'react';
import { Modal, MainLoader, FormFieldInputNew, useForm, ActionButton, SvgLazy, ExternalLink, Heading, Text } from "@netapp/bxp-design-system-react";
import { ErrorMonochromeIconsIcon as Error } from "@netapp/bxp-design-system-react/icons/monochrome";
import styles from "./NoAccountDialog.module.scss"
import {useDispatch, useSelector} from 'react-redux';
import * as yup from 'yup';
import { setItemAnon } from "utils/localstorage";
import { appComponents as i18nNamespace } from "../../../i18n/namespace";
import { useTranslation } from "react-i18next";

const useaccountFormSchema= (t) => {
    return  yup.object().shape({
    accountName: yup
        .string()
        .matches(/^[a-zA-Z0-9]*$/, t("account_name_match"))
        .required(t("name_is_required"))
});
}

export default React.memo(() => {
    const isReloading = useSelector(state => state.app.isReloading);
     const { t } = useTranslation(i18nNamespace);
    const name = useSelector(state => state.auth.firstName);
    const isCreatingAccount = useSelector(state => state.tenancy.creatingAccount);
    const creatingAccountFailed = useSelector(state => state.tenancy.creatingAccountFailed);
    const dispatch = useDispatch();
    const accountFormSchema = useaccountFormSchema(t);

    const form = useForm({accountName: ""}, accountFormSchema);
    const { handleFormSubmit, formState } = form;

    const createAccount = () => {
        setItemAnon({itemKey: `dontShowNewBlue`}, true)
        dispatch({
            type: 'TENANCY:CREATE-ACCOUNT',
            payload: {accountName: formState.accountName}
        });
    };

    if(isReloading) {
        return <MainLoader/>
    }

    return <Modal className={styles.base}>
        <div className={styles['create-first-account']}>
            <div className={styles['left-side']}>
                <Heading bold color="text-title">{t("hi")} {name},<br/>{t("welcome_to_bluexp")}</Heading>
                <SvgLazy srcP={import("./woman-shpagat.svg")}/>
            </div>
            <div className={styles['right-side']}>
                <Text level="16">{t("creating_an_account")}</Text>
                <Text level="16">{t("ask_account_admin")}
                    <ExternalLink
                        variant="text"
                        trackCategory="Tenancy"
                        trackLabel="First Account - Learn how to Add User"
                        href="https://docs.netapp.com/us-en/occm/task_setting_up_cloud_central_accounts.html#adding-users"
                        newTab> {t("learn_to_add_user")}</ExternalLink>
                </Text>
                <FormFieldInputNew
                    name="accountName"
                    label={t("account_name")}
                    disabled={isCreatingAccount}
                    form={form}
                    autoComplete="off"
                />
                <ActionButton onClick={handleFormSubmit(createAccount)} isSubmitting={isCreatingAccount}>{t("create_account")}</ActionButton>
                {creatingAccountFailed && <div className={styles.failed}><Error/>{t("account_creation_failed")}</div>}
            </div>
        </div>
    </Modal>;
});
